export default {"src":"/_next/static/media/snickers.1bd5fd36.svg","height":121,"width":188,"blurWidth":0,"blurHeight":0};